import card from '../../components/card'

export default {
  name: 'cropcard',
  components: { card },
  props: ['index', 'source'],
  data () {
    return {
    }
  }
}
